import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useAlert } from 'react-alert'

import { AttestModel, CustomerModel } from '../../../domain/models'
import {
  fetchCustomer,
  fetchAttest,
  resetAttest,
  saveAttest,
  updateAttest
} from '../../../main/usecases'

import { maskCpf, formatDate } from '../../utils'
import { useModalBox, useOnChangeDetect } from '../../contexts'
import {
  Button,
  EditorCard,
  ServicesHeader,
  SubHeader,
  ResetModal
} from '../../components'

import {
  IconSaveSvg,
  IconReturnSvg,
  PrinterSvg
} from '../../assets/icons/svgComponents'

import * as S from './styles'

const Attests = ({ match }: any) => {
  const [customer, setCustomer] = useState<CustomerModel>()
  const [attest, setAttest] = useState<AttestModel>()
  const [attestData, setAttestData] = useState('')
  const [loading, setLoading] = useState(false)
  const [resetLoading, setResetLoading] = useState(false)
  const alert = useAlert()
  const { modalBox } = useModalBox()
  const { refresh, setRefresh } = useOnChangeDetect()

  const handleOpenResetModal = () => {
    modalBox(
      <ResetModal
        id={match?.params?.idassessment}
        loading={resetLoading}
        resetDocument={resetAttest}
        setDocument={setAttest}
        setDocumentData={setAttestData}
        document="atestado"
      />,
      'Resetar Atestado',
      '32%'
    )
  }

  const onSaveAttest = async () => {
    const body = {
      ...(attest?.cdAtestado && {
        cdAtestado: attest?.cdAtestado
      }),
      atestado: attestData
    }

    try {
      setResetLoading(true)
      if (attest?.cdAtestado) {
        await updateAttest({
          id: match?.params?.idassessment
        }).update(body)
        setRefresh((prev: any) => !prev)
      } else {
        await saveAttest({
          id: match?.params?.idassessment
        }).post(body)
        setRefresh((prev: any) => !prev)
      }
      setResetLoading(false)
    } catch (error) {
      console.error(error)
    }
  }

  const handlePrinter = async () => {
    const body = {
      ...(attest?.cdAtestado && {
        cdAtestado: attest?.cdAtestado
      }),
      atestado: attestData
    }

    try {
      if (attest?.cdAtestado) {
        await updateAttest({
          id: match?.params?.idassessment
        }).update(body)
        document
          ?.querySelectorAll('[style="display: block !important;"]')[0]
          ?.setAttribute('style', 'display:none !important;')
        window.print()
        setRefresh((prev: any) => !prev)
      } else {
        await saveAttest({
          id: match?.params?.idassessment
        }).post(body)
        document
          ?.querySelectorAll('[style="display: block !important;"]')[0]
          ?.setAttribute('style', 'display:none !important;')
        window.print()
        setRefresh((prev: any) => !prev)
      }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    window.onafterprint = function () {
      document
        ?.querySelectorAll('[style="display:none !important;"]')[0]
        ?.setAttribute('style', 'display: block !important;')
    }
  }, [])

  useEffect(() => {
    ;(async () => {
      try {
        const responseCustomer = await fetchCustomer({
          id: match?.params?.id
        }).load()
        setCustomer(responseCustomer)
        const responseAttest = await fetchAttest({
          id: match?.params?.idassessment
        }).load()
        setAttest(responseAttest)
        setAttestData(responseAttest?.atestado)
      } catch (error) {
        console.error(error)
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [match.params.id, match?.params?.idassessment, refresh])

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    const body = {
      ...(attest?.cdAtestado && {
        cdAtestado: attest?.cdAtestado
      }),
      atestado: attestData
    }

    try {
      setLoading(true)
      if (attest?.cdAtestado) {
        await updateAttest({
          id: match?.params?.idassessment
        }).update(body)
        alert.show('Atualizado com sucesso!', {
          type: 'success',
          timeout: 4000
        })
        setRefresh((prev: any) => !prev)
      } else {
        await saveAttest({
          id: match?.params?.idassessment
        }).post(body)
        alert.show('Salvo com sucesso!', {
          type: 'success',
          timeout: 4000
        })
        setRefresh((prev: any) => !prev)
      }
    } catch (error) {
      console.error(error)
      alert.show('Error ao salvar/atualizar o Atestado', {
        type: 'error',
        timeout: 4000
      })
    } finally {
      setTimeout(() => {
        setLoading(false)
      }, 1500)
    }
  }
  console.log(customer)

  return (
    <S.Wrapper>
      {customer && (
        <SubHeader
          name={customer.nome}
          cpf={maskCpf(customer.cpf)}
          page="Voltar"
          link={`/meus-pacientes/${match?.params?.id}/prontuario`}
        />
      )}
      <S.CardContainer>
        <ServicesHeader
          onClick={onSubmit}
          title="Atestado"
          hasPrinter
          disabled={loading}
          onPrinter={handlePrinter}
        />
        <EditorCard
          docType="atestado"
          data={attest && attest?.atestado}
          setData={setAttestData}
          title=""
          height="auto"
          hasReset
          openResetModal={() => {
            onSaveAttest()
            handleOpenResetModal()
          }}
        />
        <S.ButtonsContainer className="no-print">
          <Button
            initialIcon={<IconSaveSvg />}
            className="button-save"
            onClick={onSubmit}
            disabled={loading}
          >
            Salvar
          </Button>
          <Button
            initialIcon={<PrinterSvg />}
            className="button-printer"
            onClick={handlePrinter}
          >
            Imprimir
          </Button>
          <Button
            initialIcon={<IconReturnSvg />}
            hasSecodaryButton
            className="button-return-to-list"
          >
            <Link to={`/meus-pacientes/${match?.params?.id}/prontuario`}>
              Retornar à listagem
            </Link>
          </Button>

          {attest?.dataUltimaModificacao && (
            <p>
              Data da última atualização:{' '}
              {formatDate(attest?.dataUltimaModificacao || '')}
            </p>
          )}
        </S.ButtonsContainer>
      </S.CardContainer>
    </S.Wrapper>
  )
}
export default Attests
